export default __webpack_public_path__ + "static/media/Arrow Left.eb3305d3.svg";